import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login';
import autoLogin from './views/autoLogin';
import notfound from './views/notfound';
import store from './store/index'
import home from './views/home'
import toc from './views/toc'
import preAssessment from './views/preAssessment'
import assessment from './views/assessment'
import results from './views/results'
import pdf from './views/pdf'
import topic from './views/topic'
import submissions from './views/submissions'
import courseTeacher from './views/courseTeacher'
import forumTeacher from './views/forumTeacher'
import topicTeacher from './views/topicTeacher'
import assignmentsTeacher from './views/assignmentsTeacher'
import submissionsTeacher from './views/submissionsTeacher'
import session from './views/session'
import sessionTeacher from './views/sessionTeacher'
import material from './views/material'
import QrCodeLogin from './views/qrCodeLogin.vue';

let menu = store.state.modelMenu
let extraMenu = store.state.extraMenu
let main = menu.filter(x => !x.subs)
let subs = [].concat(...menu.filter(x => x.subs).map(x => x.subs))
let all = main.concat(subs)
let allMapped = all.map(x=>{
  return {
    path: x.path,
    name: x.text,
    component: () => import(`./views/${x.text}`),
  }
}).concat(extraMenu.map(x=>{
  return {
    path: x.path,
    name: x.text,
    component: () => import(`./views/${x.text}`),
  }
}))
// console.log('------------------------------------');
// console.log(all);
// console.log('------------------------------------');


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    // console.log(to)
    // console.log(from)
    //next()
  },
  routes: [
    {
      path: '/home',
      name: 'home',
      component: home,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/qrcodelogin',
      name: 'qrcodelogin',
      component: QrCodeLogin,
    },
    {
      path: '/v/:hash',
      name: 'verify',
      component: Login,
    },
    {
      path: '/04032018/:e/:s',
      name: 'autologin',
      component: autoLogin,
    },
    {
      path: '/topic/:hash',
      name: 'topic',
      component: topic,
    },
    {
      path: '/session/:hash',
      name: 'session',
      component: session,
    },
    {
      path: '/submissions/:hash',
      name: 'submissions',
      component: submissions,
    },
    {
      path: '/admin-course/:hash',
      name: 'courseTeacher',
      component: courseTeacher,
    },
    {
      path: '/admin-forum/:hash',
      name: 'forumTeacher',
      component: forumTeacher,
    },
    {
      path: '/admin-topic/:hash',
      name: 'topicTeacher',
      component: topicTeacher,
    },
    {
      path: '/admin-assignments/:hash',
      name: 'assignmentsTeacher',
      component: assignmentsTeacher,
    },
    {
      path: '/admin-submissions/:hash',
      name: 'submissionsTeacher',
      component: submissionsTeacher,
    },
    {
      path: '/admin-session/:hash',
      name: 'sessionTeacher',
      component: sessionTeacher,
    },
    {
      path: '/material/:hash?',
      name: 'material',
      component: material,
    },
    {
      path: '/toc',
      name: 'toc',
      component: toc,
    },
    {
      path: '/register',
      name: 'register',
      component: Login,
    },
    {
      path: '/pre-assessment',
      name: 'preAssessment',
      component: preAssessment,
    },
    {
      path: '/assessment',
      name: 'assessmentPage',
      component: assessment,
    },
    {
      path: '/results',
      name: 'assessmentResults',
      component: results,
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: pdf,
    },
    {
      // will match everything
      path: '*',
      component: notfound,
    }
  ].concat(allMapped)
})

router.beforeEach((to, from, next) => {
  let noGate = ['home', 'login', 'register', 'toc', 'verify', 'autologin', 'qrcodelogin']
  let user = store.state.user

  const paths_with_access = menu.filter(item => item.access).reduce((acc, curr) => {
    acc[curr.path] = curr.access
    return acc
  }, {})

  if (user && Object.keys(paths_with_access).includes(to.path)) {
    // That means the user is trying to reach a restricted path
    // soo we need to make sure he has the access

    if (!Boolean(user[paths_with_access[to.path]])) {
      return next('/home')
    }
  }

  console.log(`Here you goo`, to.name);

  // console.log(to.name)
  if(noGate.includes(to.name)) {
    next()
  } else if (user && user.role && !noGate.includes(to.name)) {
    let a = all.filter(x => x.text == to.name)
    .filter(x => x.roles && x.roles.includes(user.role))
    if ((a && a.length) || to.name != 'home') {
      next()
    } else {
      next({ name: 'home'})
    }
  } else if (!user && !noGate.includes(to.name)) {
    next({ name: 'home'})
  }
  else {
    next()
  }
})


Vue.use(Router);

export default router
